"use client";

import React from "react";
import { MessageCircle as WhatsApp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheAirobotMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223707" id="airobot-mission" className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden border-y border-foreground/10">
      {}
      <div className="absolute top-0 left-0 w-4 h-4 border-l-2 border-t-2 border-primary m-4 z-20" />
      <div className="absolute top-0 right-0 w-4 h-4 border-r-2 border-t-2 border-primary m-4 z-20" />
      <div className="absolute bottom-0 left-0 w-4 h-4 border-l-2 border-b-2 border-primary m-4 z-20" />
      <div className="absolute bottom-0 right-0 w-4 h-4 border-r-2 border-b-2 border-primary m-4 z-20" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="relative group order-2 lg:order-1">
            <div className="absolute -inset-1 bg-primary/10 rounded-lg blur-sm opacity-50 group-hover:opacity-70 transition-opacity duration-700" />
            <div className="relative aspect-square lg:aspect-[4/5] rounded-lg overflow-hidden border-8 border-card shadow-xl bg-muted">
              <img src="https://fun-bengal.10web.cloud/wp-content/uploads/2026/05/SEND-IT-1-scaled.jpg" alt="Alvin Chong founder of Send It Fit vintage collage mobile personal training Singapore calisthenics" className="w-full h-full object-cover grayscale-[0.2] sepia-[0.1] group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100" />
              {}
              <div className="absolute inset-0 border border-foreground/5 pointer-events-none" />
              <div className="absolute top-4 left-4 w-3 h-3 bg-primary rounded-lg" />
            </div>
          </div>

          {}
          <div className="order-1 lg:order-2 bg-card/60 backdrop-blur-sm border border-border p-8 sm:p-10 lg:p-12 rounded-lg shadow-md relative overflow-hidden">
            {}
            <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662846/img/vintage_paper_texture.png')] bg-repeat opacity-10 pointer-events-none mix-blend-multiply" />

            <div className="relative z-10">
              <Badge variant="outline" className="mb-8 font-mono text-xs tracking-widest border-primary text-primary bg-transparent px-3 py-1 uppercase">founder</Badge>

              <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold mb-4 text-foreground tracking-tight leading-tight drop-shadow-[4px_4px_0px_rgba(0,0,0,0.15)]">
                Alvin <br className="hidden sm:block" />
                <span className="text-primary font-['Heritage_Script']">
                  Chong
                </span>
              </h2>
              <p className="font-mono text-sm text-primary uppercase tracking-widest mb-8">Calisthenics • Fat Loss • Muscle Building • Fasting • functional fitness</p>

              <div className="columns-1 sm:columns-2 gap-x-8 text-base text-foreground/80 leading-relaxed font-default space-y-6 sm:space-y-0">
                <p>Alvin has been an athlete and working out his whole life, and made every mistake under the sun so you don't have to. He used to be a skinny a**, now he's just an a**. <br /><br />&nbsp;He has been an aggressive inline skater for 25 years and competed internationally for 10 years. He has a diploma in sport and wellness management from Nanyang Polytechnic, a bachelor in business from University College Dublin, and is a NCSF certified personal trainer. <br /><br />His purpose is to inspire and enable people to do what they love, live life to the fullest, and live with no regrets. He firmly believes that the ability to move is the greatest privilege not taken advantage of, and he's here to help you realise your physical and mental potential, and most of all, enjoy yourself while doing it. Pain is inevitable but suffering is optional!</p>
              </div>

              <div className="mt-10 pt-8 border-t border-border flex items-center justify-between">
                <div className="flex flex-col">
                  <span className="font-mono text-xs text-primary uppercase tracking-wider mb-1">Ready to lock in?</span>
                  <span className="font-default text-sm text-foreground font-semibold">Let's send it together!</span>
                </div>
                <Link to="https://wa.me/6588990728">
                  <Button variant="default" size="icon" className="rounded-lg w-12 h-12 bg-primary text-primary-foreground hover:translate-y-[-2px] hover:shadow-[6px_6px_0px_var(--color-foreground)] transition-all duration-300">
                    <WhatsApp className="size-5" />
                    <span className="sr-only">Get Started</span>
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}